import createParagraphPlugin from "./createParagraphPlugin";

export default createParagraphPlugin;
